import React, { ReactElement } from 'react'

import { Widget, Typography, Grid, Flex, Image, Placeholder } from '~ui'
import { formatCurrency } from '~utils'
import { formatDate } from '~utils/time-new'

interface CartWidgetProps {
  artistFullName: string
  cartItemImage: string
  eventDate: string
  quantity: number
  price: number
  actions: Array<ReactElement>
  loading?: boolean
  isPackage?: boolean
}

const CartWidget: React.FC<CartWidgetProps> = ({
  artistFullName,
  cartItemImage,
  eventDate,
  isPackage,
  quantity,
  price,
  actions,
  loading,
}) => {
  if (loading) {
    return (
      <Widget borderRadius="md" backgroundColor="g-orange-1">
        <Grid gap={20} padding="20px" minWidth="100%">
          <Placeholder style={{ height: 40 }} />
          <Grid
            gap={20}
            gridAutoFlow="column"
            gridAutoColumns="auto 1fr"
            justifyItems="start"
            alignItems="center"
          >
            <Placeholder style={{ width: 100, height: 100, borderRadius: '50%' }} />
            <Flex flexDirection="column" width="100%">
              <Placeholder style={{ height: 20, width: '30%', margin: '5px 0' }} />
              <Placeholder style={{ height: 20, width: '70%', margin: '5px 0' }} />
              <Placeholder style={{ height: 20, width: '40%', margin: '5px 0' }} />
            </Flex>
          </Grid>
          <Flex justifyContent="space-between" alignItems="center" paddingBottom={20}>
            <Placeholder style={{ height: 20, width: '49%', padding: 20 }} />
            <Placeholder style={{ height: 20, width: '49%', padding: 20 }} />
          </Flex>
        </Grid>
      </Widget>
    )
  }

  return (
    <Widget borderRadius="md" backgroundColor="g-orange-1" borderColor="g-orange" actions={actions}>
      <Grid gap={20} padding="20px" paddingBottom={0}>
        <Typography.Text>
          You have an active cart. Complete order or clear cart to proceed.
        </Typography.Text>
        <Grid
          gap={20}
          gridAutoFlow="column"
          gridAutoColumns="auto 1fr"
          justifyItems="start"
          alignItems="center"
        >
          <Image src={cartItemImage} rounded width={100} height={100} />
          <Flex flexDirection="column" width="100%">
            <Typography.Text size="lg" bold>
              {artistFullName}
            </Typography.Text>
            <Typography.Text color="g-gray-1">{formatDate(eventDate)}</Typography.Text>
            <Typography.Text color="g-gray-1">
              {quantity} {!isPackage && (quantity === 1 ? 'ticket' : 'tickets')}
              {isPackage && (quantity === 1 ? 'package' : 'packages')} · {formatCurrency(price, 0)}
            </Typography.Text>
          </Flex>
        </Grid>
      </Grid>
    </Widget>
  )
}

export default CartWidget
